import { postRequest } from '@/libs/axios';


// 商家发布列表
export const getStoreActivityDataList = (params) => {
    return postRequest('/api/groupActivity/storeSearch', params)
}
// 团长发布列表
export const getColonelActivityDataList = (params) => {
    return postRequest('/api/groupActivity/colonelSearch', params)
}